import React from "react";
import Reveal from "./Reveal";
import { TESTIMONIALS } from "../data/testimonials";
import { Star, Quote } from "lucide-react";

export default function Testimonials() {
  return (
    <div
      className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5"
      data-testid="testimonials-grid"
    >
      {TESTIMONIALS.map((t, i) => (
        <Reveal
          key={i}
          className="group rounded-3xl bg-white border border-[#E5E7EB] p-7 hover:-translate-y-1 hover:border-[#3282B8] hover:shadow-[0_20px_40px_-20px_rgba(15,76,117,0.3)] transition-all relative overflow-hidden"
        >
          <Quote className="absolute top-6 right-6 w-10 h-10 text-[#FF6B00]/15" />
          <div className="flex items-center gap-1 mb-4">
            {Array.from({ length: t.rating }).map((_, k) => (
              <Star key={k} className="w-4 h-4 fill-[#FFB341] text-[#FFB341]" />
            ))}
          </div>
          <p className="text-[#1B262C]/85 text-sm md:text-base leading-relaxed mb-5">
            &ldquo;{t.text}&rdquo;
          </p>
          <div className="pt-4 border-t border-[#E5E7EB] flex items-center justify-between">
            <div>
              <div className="font-display font-bold text-[#0F4C75]">{t.name}</div>
              <div className="text-xs text-[#1B262C]/55">{t.area}</div>
            </div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#FF6B00]">
              {t.service}
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
}
